<template>
  <v-app>
    <v-navbar :drawer="_fnSetDrwer" />
    <v-sideMenu :drawer="drawer" :showMenu="_fnShowMenu" />
    <v-main :style="{ background: '#EEEEEE', height: '100%' }">
      <router-view :style="{ margin: '8px 8px', maxHeight: '100%' }" />
    </v-main>
    <v-notification />
  </v-app>
</template>

<script>
import Navbar from "./components/Navbar";
import SideMenu from "./components/SideMenu";

export default {
  components: {
    "v-navbar": Navbar,
    "v-sideMenu": SideMenu,
  },
  data() {
    return {
      drawer: true,
    };
  },
  created() {
    this.fnSocket();
    this._fnShowMenu();
  },
  watch: {
    "$vuetify.breakpoint.name": function () {
      this._fnShowMenu();
    },
  },
  methods: {
    _fnSetDrwer() {
      this.drawer = !this.drawer;
    },
    _fnShowMenu() {
      this.drawer = !this.$vuetify.breakpoint.xs;
    },
  },
};
</script>

<style>
::-webkit-scrollbar {
  width: 5px;
  height: 8px;
}
::-webkit-scrollbar-track {
  background: #f1f1f1;
}
::-webkit-scrollbar-thumb {
  background: #888;
}
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.v-application {
  font-size: 14px;
}
.text-start {
  font-size: 12px !important;
}
.v-list--dense .v-list-item {
  min-height: 32px !important;
  height: 32px !important;
}
.v-select .v-select__selection--disabled {
  color: black !important;
}
.v-text-field .v-label {
  transform: translateY(-18px) scale(0.75);
  font-weight: bold !important;
}
.v-picker--time .v-picker__title {
  height: 88px !important;
}
.v-input--selection-controls {
  margin: 0px !important;
}
/* .v-data-table__wrapper {
  max-height: 500px;
} */
</style>
